/** Google Calendar items -> the shape the "Live" section draws. */

const stripHtml = (s) =>
  s.replace(/<br\s*\/?>/gi, ' $ ')
    .replace(/<\/?(p|div|li|ul|ol)[^>]*>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'");

function startOf(item) {
  const s = item.start || {};
  if (s.dateTime) return { date: new Date(s.dateTime), allDay: false, tz: s.timeZone };
  if (s.date) {
    const [y, m, d] = s.date.split('-').map(Number);
    return { date: new Date(y, m - 1, d), allDay: true, tz: undefined };
  }
  return null;
}

function fmt(date, opts, tz) {
  try {
    return new Intl.DateTimeFormat('en-US', tz ? { ...opts, timeZone: tz } : opts).format(date);
  } catch (e) {
    return new Intl.DateTimeFormat('en-US', opts).format(date);
  }
}

/**
 * Description convention (unchanged):
 *   "First detail $ Second detail $ Button label LINK https://... $$ https://tickets"
 * Everything after "$$" replaces the default calendar link.
 */
export function toEvent(item, keyword = 'Ize') {
  const start = startOf(item);
  if (!start) return null;
  const title = item.summary || '';
  const raw = stripHtml(item.description || '').trim();
  // this calendar can be shared with other projects: only keep events that mention the keyword
  if (keyword) {
    const word = new RegExp(`\\b${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
    if (!word.test(`${title} ${raw}`)) return null;
  }

  const [main, ticket] = raw.split('$$');
  const details = (main || '').split(/\s\$\s/).map((p) => p.trim()).filter(Boolean).map((p) => {
    if (p.includes(' LINK ')) {
      const [label, url] = p.split(' LINK ');
      return { label: label.trim(), url: (url || '').trim() };
    }
    return { text: p };
  });

  const tz = start.tz;
  return {
    id: item.id,
    title,
    where: item.location || '',
    details,
    url: (ticket || '').trim() || item.htmlLink || '',
    month: fmt(start.date, { month: 'short' }, tz),
    day: fmt(start.date, { day: 'numeric' }, tz),
    weekday: fmt(start.date, { weekday: 'long' }, tz),
    time: start.allDay ? '' : fmt(start.date, { hour: 'numeric', minute: '2-digit' }, tz),
    year: fmt(start.date, { year: 'numeric' }, tz),
    iso: start.date.toISOString(),
  };
}
